// extracted by mini-css-extract-plugin
export default {"user__list":"UserOrdersList_user__list__7pJNO","user__empty":"UserOrdersList_user__empty__geq-H"};